<template>
  <v-tooltip bottom>
    <template #activator="{ on, attrs }">
      <router-link
        v-if="linkTo"
        :to="linkTo"
      >
        <v-btn
          icon
          small
          v-bind="attrs"
          v-on="on"
        >
          <v-icon :size="size">
            {{ icon }}
          </v-icon>
        </v-btn>
      </router-link>
      <v-btn
        v-else
        icon
        small
        v-bind="attrs"
        @click="OnClick(item)"
        v-on="on"
      >
        <v-icon :size="size">
          {{ icon }}
        </v-icon>
      </v-btn>
    </template>
    <span> {{ text }}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      default: '18',
    },
    icon: {
      type: String,
      required: true,
    },
    item: {
      type: Object,
      default: null,
    },
    linkTo: {
      type: Object,
      default: null,
    },
  },
  setup(_, { emit }) {
    const OnClick = value => {
      emit('OnClick', value)
    }

    return {
      OnClick,
    }
  },
}
</script>
